import Vue from "vue";
import VueRouter, {Route, RouteConfig} from "vue-router";
import {AuthService} from "@/services/auth-service";

Vue.use(VueRouter);

function isNotLoggedInGuard(to:Route, from:Route, next:Function){
	if (!AuthService.isLoggedIn){
		next();
		return;
	}
	next({
		path: `/`
	});
}

function isLoggedInGuard(to:Route, from:Route, next:Function){
	console.log(AuthService.isLoggedIn);
	if (AuthService.isLoggedIn){
		next();
		return;
	}
	next({
		path: `/login`
	});
}


const routes: Array<RouteConfig> = [
	{
		path: "/login", beforeEnter: isNotLoggedInGuard, component: ()=>import("@/views/LoginRoute.vue"),
	},
	{
		path: "/", component: () => import("@/views/DefaultRoute.vue"), beforeEnter: isLoggedInGuard, children: []
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
